export default {
	STOPPED: 'stopped',
	RUNNING: 'running',
}
